import { render } from "./TenantDetail.vue?vue&type=template&id=558d7bea&scoped=true&ts=true"
import script from "./TenantDetail.vue?vue&type=script&lang=ts"
export * from "./TenantDetail.vue?vue&type=script&lang=ts"

import "./TenantDetail.vue?vue&type=style&index=0&id=558d7bea&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558d7bea"]])

export default __exports__